import { ScrollingModule } from '@angular/cdk/scrolling';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import {
  UserProfileAboutSubpageComponent,
  UserProfileClassesSubpageComponent,
  UserProfileCollectionsSubpageComponent,
  UserProfileComponent,
  UserProfileFeedbackSubpageComponent,
  UserProfileLessonsSubpageComponent,
  UserProfileNavComponent,
  UserProfilePublicationsSubpageComponent,
  UserProfileSchoolsSubpageComponent,
  UserProfileTeachingSubpageComponent,
} from '@app/account/profile';
import { UserProfilePageComponent } from '@app/account/profile/user-profile-page/user-profile-page.component';
import { PaymentCheckoutWizardModule } from '@app/account/shared/payment-checkout-wizard/payment-checkout-wizard.module';
import { UserServiceFormModule } from '@app/account/teacher-page/user-service-form/user-service-form.module';
import { CollectionCardMiniModule, CollectionCardModule } from '@app/collections';
import { LocaleSharedModule } from '@app/i18n/locale-shared.module';

import { ContentCardModule } from '@app/library/content-card/content-card.module';
import { CategoriesItemComponent } from '@app/library/panes/categories-content-filter/categories-item/categories-item.component';
import { FilterContentComponent } from '@app/library/panes/filter-content/filter-content.component';
import { LibraryPanesModule } from '@app/library/panes/library-panes.module';
import { MeetingReviewFormComponent } from '@app/library/panes/meeting-review-form/meeting-review-form.component';
import { UserServiceCardFullModule } from '@app/meetings/user-service-card-full/user-service-card-full.module';
import { SchoolCardModule } from '@app/schools/school-card/school-card.module';
import { ContentNotFoundModule } from '@app/shared';
import { UserCardMiniModule } from '@app/users/user-card-mini/user-card-mini.module';
import { BookmarkComponent } from '@core/components/bookmark/bookmark.component';
import { DatetimePickerModule } from '@core/components/datetime-picker';
import { EmptyComponent } from '@core/components/empty/empty.component';
import { HorizontalScrollMenuModule } from '@core/components/horizontal-scroll-menu/horizontal-scroll-menu.module';
import { MobileModalModule } from '@core/components/mobile-modal/mobile-modal.module';
import { ModalModule } from '@core/components/modal/modal.module';
import { PaginationModule } from '@core/components/pagination/pagination.module';
import { ReviewsCarouselModule } from '@core/components/reviews-carousel/reviews-carousel.module';
import { UserServiceCardModule } from '@core/components/service-card/user-service-card.module';
import { SpinnersModule } from '@core/components/spinners/spinners.module';
import { TitleModule } from '@core/components/title/title.module';
import { CoreModule } from '@core/core.module';
import { PipesModule } from '@core/pipes/pipes.module';
import { DragScrollComponent } from '@le2xx/ngx-drag-scroll';

import { ComplaintFormModule } from '@shared/complaint-form/complaint-form.module';
import { IconComponent } from '@shared/icon/icon.component';
import { RatingComponent } from '@shared/rating/rating.component';
import { SkeletonComponent } from '@shared/skeleton/skeleton.component';
import { PaymentFormCardSelectorModule } from 'lingo2-forms';
import { DateFnsModule } from 'lingo2-ngx-date-fns';
import { ClickOutsideModule } from 'ng-click-outside';
import { InViewportModule } from 'ng-in-viewport';
import { LazyLoadImageModule } from 'ng-lazyload-image';
import { ClipboardModule } from 'ngx-clipboard';
import { OnUiButtonModule, OnUiCardMenuModule, OnUiCoverModule, OnUiReceiptModule } from 'onclass-ui';
import { FeedPostFormComponent } from '../feed/feed-post-form/feed-post-form.component';
import { LessonComponent } from '../library/panes/grid-card-universal/components/lesson/lesson.component';
import { UserServiceSurfaceBlockComponent } from '../meetings/user-service-card-full/user-service-surface-block/user-service-surface-block.component';
import { InviteToMeetingModule } from './shared/invite-to-meeting/invite-to-meeting.module';

@NgModule({
  imports: [
    LocaleSharedModule,
    CommonModule,
    RouterModule,
    CoreModule,
    TitleModule,
    DragScrollComponent,
    PaginationModule,

    ClipboardModule,
    SpinnersModule,
    DateFnsModule,
    ClickOutsideModule,
    PipesModule,
    DatetimePickerModule,
    ScrollingModule,
    LazyLoadImageModule,
    FormsModule,
    InviteToMeetingModule,
    HorizontalScrollMenuModule,
    UserCardMiniModule,
    PaymentFormCardSelectorModule,
    OnUiReceiptModule,
    OnUiButtonModule,
    IconComponent,
    SchoolCardModule,
    ComplaintFormModule,
    ModalModule,
    MobileModalModule,
    OnUiCoverModule,
    OnUiCardMenuModule,
    ContentNotFoundModule,
    CollectionCardMiniModule,
    CollectionCardModule,
    UserServiceCardFullModule,
    UserServiceCardModule,
    CategoriesItemComponent,
    PaymentCheckoutWizardModule,
    UserProfileAboutSubpageComponent,
    ReviewsCarouselModule,
    EmptyComponent,
    BookmarkComponent,
    InViewportModule,
    FilterContentComponent,
    LibraryPanesModule,
    RatingComponent,
    UserServiceFormModule,
    SkeletonComponent,
    ContentCardModule,
    MeetingReviewFormComponent,
    FeedPostFormComponent,
    LessonComponent,
    UserServiceSurfaceBlockComponent,
  ],
  exports: [
    UserProfilePageComponent,
    UserProfileComponent,
    UserProfileTeachingSubpageComponent,
    UserProfilePublicationsSubpageComponent,
    UserProfileCollectionsSubpageComponent,
    UserProfileFeedbackSubpageComponent,
    UserProfileClassesSubpageComponent,
    UserProfileLessonsSubpageComponent,
    UserProfileSchoolsSubpageComponent,
    UserProfileNavComponent,
  ],
  declarations: [
    UserProfilePageComponent,
    UserProfileComponent,
    UserProfileTeachingSubpageComponent,
    UserProfilePublicationsSubpageComponent,
    UserProfileCollectionsSubpageComponent,
    UserProfileFeedbackSubpageComponent,
    UserProfileClassesSubpageComponent,
    UserProfileLessonsSubpageComponent,
    UserProfileSchoolsSubpageComponent,
    UserProfileNavComponent,
  ],
})
export class AccountSharedModule {}
